import React, { ButtonHTMLAttributes } from "react";
import style from "../../scss/export.module.scss";
import { CloseCircleIcon, CloseIcon } from "../Icons";
import "./close-button.scss";
import { getWindow } from "../../utils";

export interface TCloseButton extends ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    onDarkBackground?: boolean;
    icon?: "close" | "close-circle";
    iconSize?: number;
    iconColor?: string;
}

export const CloseButton = ({
    className = "",
    onDarkBackground = false,
    icon = "close",
    iconSize = 24,
    iconColor = style.blackColor,
    ...props
}: TCloseButton) => {
    const ariaLabel = getWindow().__TEXTS__?.["close"] || "Close";

    const renderIcon = () => {
        const color = onDarkBackground ? style.whiteColor : iconColor;

        if (icon === "close-circle") {
            return <CloseCircleIcon size={iconSize} color={color} />;
        }

        return <CloseIcon size={iconSize} color={color} />;
    };

    return (
        <button
            type="button"
            title={ariaLabel}
            className={`c-close-button ${className}`}
            aria-label={ariaLabel}
            {...props}
        >
            {renderIcon()}
        </button>
    );
};
